import { API_ERROR_CODES } from './index.ts';

type ApiIsPasswordBlacklistedResult = {
  data?: {
    passwordBlacklisted: boolean;
  };
  errorCode?: API_ERROR_CODES;
  errorMessage?: string;
};

export const apiIsPasswordBlacklisted = async (password: string): Promise<ApiIsPasswordBlacklistedResult> => {
  // We are just using the JCSConnect /isPasswordBlacklisted endpoint
  const connectApiBaseUrl = import.meta.env.VITE_CONNECT_API_BASE_URL;

  return fetch(`${connectApiBaseUrl}/connect/api/v1/demo/isPasswordBlacklisted`, {
    method: 'POST',
    body: JSON.stringify({ password }),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        const errorMessage = await response.text();
        return {
          errorCode: API_ERROR_CODES.GENERIC,
          errorMessage,
        };
      }

      const responseJson = await response.json();

      return { data: responseJson } as ApiIsPasswordBlacklistedResult;
    })
    .catch(() => ({
      errorCode: API_ERROR_CODES.GENERIC,
    }));
};
